import { render, staticRenderFns } from "./BlogPeak.vue?vue&type=template&id=00aff005&"
import script from "./BlogPeak.vue?vue&type=script&lang=js&"
export * from "./BlogPeak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports